<template>
  <div class="sub_do">
    <div class="sub_search">
      <!--<div class="pic" @click="getSubDoDate"><img src="../../assets/img/search_icon.png" alt=""></div>-->
      <input
        type="text"
        :placeholder="$t('sub_index.search_plc_a')"
        v-model="keyword"
      /><a href="#" @click="getSubDoDate">{{ $t("sub_index.search") }}</a>
    </div>
    <div class="sub_list">
      <div class="sub_list_con">
        <scroll
          class="wrapper"
          :data="subDoData"
          :pulldown="pulldown"
          :pullup="pullup"
          @pulldown="getSubDoDate"
          @scrollToEnd="getSubDoDate('up')"
        >
          <ul class="content">
            <li
              v-for="(item, index) in subDoData"
              :key="index"
              @click="getSubDoReportDate(item)"
            >
              <img :src="item.avatar ? item.avatar : defaultHeadImg" alt="" />
              <div class="top">
                <h4 class="over-hide">{{ item.username }}</h4>
                <span
                  :class="{
                    pass: item.is_pass == 1,
                    unPass: item.is_pass == 0,
                  }"
                  >{{ item.rule_practice_use_count
                  }}{{ $t("sub_index.twice") }}</span
                >
              </div>
              <div class="bottom">
                <span class="tit over-hide">{{ item.resources_name }}</span>
                <span class="time fr over-hide">{{
                  item.last_submit_time
                }}</span>
              </div>
            </li>
          </ul>
          <div class="loading-no" v-if="subDoData.length == 0">
            <span>{{ $t("sub_report.noContent") }}</span>
          </div>
          <div class="loading-wrapper" v-else v-show="pullupFlag">
            <img
              src="../../assets/img/loading.gif"
              alt=""
              v-show="pullupFlagImg"
            />{{ pullupValue }}
          </div>
        </scroll>
      </div>
    </div>

    <!--实践列表弹出框-->
    <div class="model_over model_xq" v-show="doFlag">
      <div class="model_data">
        <div class="title">
          <h6>{{ $t("sub_index.do") }}<i @click="doFlag = !doFlag"></i></h6>
        </div>
        <div class="model_con">
          <ul>
            <li>
              <span>{{ $t("sub_index.num") }}</span>
              <span>{{ $t("sub_index.name") }}</span>
            </li>
            <li
              @click="goDetail(item)"
              v-for="(item, index) in subDoReportList"
              :key="index"
            >
              <span>{{ index + 1 }}</span>
              <span class="over-hide">{{ item.practice_name }}</span>
              <img src="../../assets/img/new/enter.png" alt="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--提示框-->
    <div class="model model_slide" v-show="showModel">{{ modelValue }}</div>
  </div>
</template>
<script>
import defaultHeadImg from "@/assets/img/new/default.png";
import scroll from "@/components/better_scroll";
export default {
  data() {
    return {
      keyword: "", //搜索关键词
      login_name: "", //登录名
      username: "", //用户名
      resources_name: "", //资源名
      trainplan_name: "", //计划项目名
      subDoData: [], //实践数据
      subListData: [], //实践数据暂存
      subDoReportList: [], //实践弹框数据
      defaultHeadImg: defaultHeadImg,
      showModel: false,
      modelValue: "", //提示框内容
      study_status: 2,
      doFlag: false, //实践列表弹出框
      page: 1,

      pulldown: true,
      pullup: true,
      pullupFlag: false,
      pullupFlagImg: false,
      pullupValue: this.$t("sub_report.loading"),
    };
  },
  created() {
    this.getSubDoDate();
  },
  /* mounted () {
     this.$nextTick(()=> {
     this.getSubDoDate();
     })
     },*/
  components: {
    scroll,
  },
  methods: {
    getSubDoDate(e) {
      if (e == "up") {
        this.pullupFlag = true;
        this.page++;
      } else {
        this.page = 1;
        this.pullupValue = this.$t("sub_report.loading");
      }
      var _this = this;
      let url = "index.php/mobile/user-follow-up/sub-follow-up-list";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),

        page: this.page,
        size: 10,
        keyword: this.keyword,
      };
      this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          //            _this.subDoData=res.data.result.list;
          if (e == "up") {
            if (_this.page <= res.data.result.pages.page_count) {
              _this.subDoData = _this.subListData.concat(res.data.result.list);
              _this.subListData = _this.subDoData.concat();
            } else {
              _this.pullupFlagImg = false;
              _this.pullupValue = this.$t("sub_report.noMore");
            }
          } else {
            _this.subDoData = res.data.result.list;
            _this.subListData = res.data.result.list;
          }
        }
      });
    },
    getSubDoReportDate(e) {
      if (e.rule_practice_use_count != 0) {
        this.doFlag = true;
        var _this = this;
        let url = "index.php/mobile/user-follow-up/practice-report-list";
        let params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),

          page: 1,
          size: 10,
          user_follow_up_id: e.id,
        };
        this.$axios.post(url, params).then(function (res) {
          if (res.data.code == 0) {
            _this.subDoReportList = res.data.result;
          } else {
            this.showModel = true;
            this.modelValue = res.data.msg;
            setTimeout(() => {
              this.showModel = false;
            }, 2000);
          }
        });
      }
    },
    loadData(e) {
      this.study_status = e;
      this.getSubDoDate();
    },
    goDetail(e) {
      this.$router.push({
        name: "sub_do_detail",
        query: {
          user_follow_up_detail_id: e.user_follow_up_detail_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_do {
  height: 100%;
  font-size: 0.22rem;
  background-color: #f6f6f6;
  .sub_search {
    width: 5.4rem;
    height: 0.48rem;
    background: rgba(255, 255, 255, 1);
    /*border:1Px solid rgba(216, 216, 216, 0.85);
       */
    border-radius: 0.04rem;
    /*margin-bottom: 0.4rem;
       */
    .pic {
      float: left;
      img {
        display: inline-block;
        float: left;
        width: 0.24rem;
        height: 0.24rem;
        margin: 0.12rem 0.18rem;
      }
    }
    input {
      float: left;
      height: 0.48rem;
      width: 4.4rem;
      padding: 0.12rem 0;
      box-sizing: border-box;
      border: 1px solid rgba(216, 216, 216, 0.85);
      text-indent: 0.22rem;
      border-right: none;
      line-height: normal;
      border-radius: 0;
    }
    a {
      display: inline-block;
      height: 0.48rem;
      line-height: 0.48rem;
      width: 1rem;
      background-color: $mColor;
      color: #fff;
      text-align: center;
      border-radius: 0 0.04rem 0.04rem 0;
    }
    @include pl-color(#a9aeaf);
  }
  .sub_list {
    .sub_list_nav {
      margin-left: 0.16rem;
      span {
        margin-right: 0.48rem;
        color: #a9aeaf;
        position: relative;
        display: inline-block;
        height: 0.42rem;
        &.cur {
          color: $mColor;
          i {
            position: absolute;
            bottom: 0;
            left: 50%;
            margin-left: -0.14rem;
            display: inline-block;
            width: 0.28rem;
            height: 0.04rem;
            background-color: $mColor;
          }
        }
      }
    }
    .sub_list_con {
      position: relative;
      .wrapper {
        position: absolute;
        left: 0;
        top: 0.2rem;
        overflow: hidden;
        height: calc(100vh - 2.8rem);
        .loading-wrapper {
          width: 100%;
          text-align: center;
          margin: 0.24rem auto;
          height: 0.4rem;
          background-color: #f6f6f6;
          color: #000;
          padding: 0;
          font-size: 0.22rem;
          img {
            display: inline-block;
            width: 0.3rem;
            height: 0.3rem;
            vertical-align: middle;
            margin-right: 0.2rem;
          }
        }
        .loading-no {
          width: 3.2rem;
          height: 3.2rem;
          margin: 0.2rem auto;
          border-radius: 50%;
          margin-left: 1rem;
          @include bg-image("../../assets/img/scale/sub/no-date");
          -webkit-background-size: 100%;
          background-size: 100%;
          color: #ccc;
          position: relative;
          span {
            font-size: 0.32rem;
            position: absolute;
            bottom: 0.1rem;
            left: 0.92rem;
          }
        }
      }
      ul {
        li {
          width: 5.4rem;
          height: 1.16rem;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(220, 220, 220, 1);
          box-shadow: 0rem 0rem 0.2rem 0rem rgba(0, 0, 0, 0.05);
          border-radius: 0.02rem;
          margin-top: 0.3rem;
          padding: 0.26rem 0.28rem;
          box-sizing: border-box;
          img {
            width: 0.66rem;
            height: 0.66rem;
            border-radius: 50%;
            float: left;
            margin-right: 0.16rem;
          }
          .top {
            h4 {
              display: inline-block;
              font-size: 0.2rem;
              color: #252631;
              max-width: 3.2rem;
            }
            span {
              float: right;
              font-size: 0.24rem;
              color: $mColor;
              height: 0.28rem;
              margin-top: -0.04rem;
            }
            /*margin-bottom: 0.1rem;
               */
          }
          .bottom {
            .tit {
              display: inline-block;
              color: #7f8485;
              font-size: 0.22rem;
              max-width: 2.6rem;
            }
            .time {
              color: #7f8485;
              font-size: 0.16rem;
            }
          }
        }
      }
    }
  }
  .model_over {
    /*visibility: hidden;
       */
    position: fixed;
    left: 0rem;
    top: 0rem;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5);
    .model_data {
      width: 6.72rem;
      /*height:7.6rem;
         */
      border-radius: 0.16rem;
      background-color: #fff;
      position: absolute;
      left: 50%;
      margin-left: -3.36rem;
      top: 2.4rem;
      .title {
        height: 0.6rem;
        line-height: 0.6rem;
        background-color: #f6f6f6;
        border-radius: 0.16rem 0.16rem 0 0;
        text-align: center;
        h6 {
          font-size: 0.24rem;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #252631;
        }
        i {
          float: right;
          display: inline-block;
          width: 0.2rem;
          height: 0.2rem;
          margin-right: 0.2rem;
          margin-top: 0.2rem;
          background: url("../../assets/img/clsicon.png") no-repeat center;
        }
      }
      .model_con {
        padding: 0.5rem;
        /*height: 7rem;
           */
        overflow: auto;
        box-sizing: border-box;
        color: #252631;
        font-size: 0.26rem;
        ul {
          li {
            width: 5.6rem;
            height: 0.8rem;
            color: #252631;
            font-size: 0.22rem;
            border-bottom: 0.02rem solid #dcdcdc;
            padding-top: 0.24rem;
            box-sizing: border-box;
            span {
              display: inline-block;
              width: 4.4rem;
              vertical-align: middle;
              &:nth-of-type(1) {
                width: 0.8rem;
              }
            }
            img {
              float: right;
              width: 0.12rem;
              height: 0.24rem;
              vertical-align: bottom;
            }
            &:nth-of-type(1) {
              font-size: 0.24rem;
              color: $mColor;
              line-height: 0.8rem;
              display: inline-block;
              vertical-align: middle;
              padding: 0;
              margin-top: -0.4rem;
            }
          }
        }
      }
    }
  }
}
</style>
